import { useAppSelector } from "@store";

const useUserInfo = () => {
  const data = useAppSelector((state) => {
    return {
      authType: state.userInfo.authType,
      name: state.userInfo.name,
      phone: state.userInfo.phone,
      birthday: state.userInfo.birthday,
    };
  });

  return data;
};

export default useUserInfo;
